<rappider-ai-abstract-chat [aiFunctionId]="aiFunctionIds.DATA_MODEL"
                           [activeProjectId]="activeProjectId"
                           [activePersonId]="activePersonId"
                           [selectedProjectModelId]="selectedProjectModelId"
                           [aiStartConfig]="aiStartConfig"
                           [initialSplitterOpen]="isEditMode"
                           [editingModelName]="editingModel?.name"
                           [showExamplePrompts]="true"
                           [projectModels]="projectModels"
                           [examplePrompts]="examplePrompts"
                           (messageSent)="onMessageSent($event)"
                           (responseAction)="onResponseAction($event)"
                           #abstractChat></rappider-ai-abstract-chat>
